module.exports = __webpack_public_path__ + "img/tabIcNewsOn.21b21409.svg";